<template>
  <div class="ui small modal" id="cancelModal">
    <i class="close icon"></i>
    <div class="header">
      Cancel Booking
    </div>
    <div class="content" v-if="!cancelled">
      <p>To cancel a booking, please provide a reservation identifier - code, email or telephone number.</p>
      <div class="ui huge fluid action input">
        <input type="text" placeholder="Enter code, telephone or email" v-model="search">
        <div class="ui primary button" @click="searchReservation">Search Booking</div>
      </div>
      <div v-if="searched">
        <div class="ui divider"></div>
        <div class="ui negative message" v-if="!reservations">
          <p>No booking was found under the provided code
          </p>
        </div>
        <div class="ui segments" v-else>
          <div class="ui segment">
            <h4>Reservation for {{ reservations[0].contact.firstName }} {{ reservations[0].contact.lastName }}</h4>
          </div>
          <div class="ui secondary segment">
            <div style="text-align: center">
              <div class="ui negative cancel-booking icon button"><i class="trash icon"></i> Cancel This Booking</div>
              <div class="ui special popup">
                <div class="header">Are you sure?</div>
                <p>This action is irreversible!</p>
                <div class="ui icon primary button" @click="cancelReservation"><i class="checkmark icon"></i> Yes, cancel</div>
              </div>
            </div>
            <table class="ui very basic table">
              <tbody>
              <tr v-for="booking in bookings">
                <td>
                  {{ booking.boat.name }}
                </td>
                <td>
                  {{ booking.hour }} h
                </td>
                <td>
                  {{ moment(booking.date).format('ll') }}
                </td>
                <td class="right aligned">
                  €{{ numeral(booking.cost).format('0,0.00') }}
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="3"><strong>Total</strong></td>
                <td class="right aligned"><strong>€{{ toPay }}</strong></td>
              </tr>
              </tfoot>

            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-else>
      <div class="ui info message" v-if="!reservation">
        <p>Your booking was cancelled!
        </p>
      </div>
    </div>
    <div class="actions">
      <div class="ui icon cancel button">
        <i class="delete icon"></i> Close
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'

  export default {
    data() {
      return {
          search: null,
          searched: false,
          reservations: [],
          bookings: [],
          cancelled: false,
          numeral: numeral,
          moment: moment
      }
    },
    mounted() {
      moment.locale('de')
    },
    watch: {
      reservations: function () {
        if (this.reservations) {
            setTimeout(() => {
              $('.cancel-booking.button').popup({
                inline: true,
                position: 'top center',
                on: 'click'
              })
              $('#cancelModal').modal('refresh')
            }, 50)
        }
      }
    },
    computed: {
      toPay() {
        if (this.reservations.length === 0) return null;

        return numeral(this.reservations.map(reservation => { return reservation.payment.total }).reduce((a, b) => {
          return a + b;
        })).format('0,0.00')
      },
    },
    methods: {
        searchReservation() {
            this.searched = false
            this.reservations = null

            services.reservationService.find({ query: {
              $or: [
                { code: this.search.toUpperCase() },
                { 'contact.email': this.search },
                { parsedTel: this.search.replace(/[^1-9]/, '') }
              ],
              status: { $in: ['reserved'] }
            }}).then(reservations => {
                this.searched = true

                if (reservations.total > 0) {
                    this.reservations = reservations.data

                    let allBookings = [].concat.apply([], this.reservations.map(reservation => {return reservation.bookings.map(booking => {return booking._id})}))

                    services.bookingService.find({ query: { _id: { $in: allBookings }, $sort: { _boat: 1, date: 1, hour: 1 }}}).then(bookings => {
                        this.bookings = bookings.data
                    })
                }
            })
        },
        cancelReservation() {
            services.reservationService.patch(null, { status: 'cancelled', statusReason: 'userAction' }, { query: { _id: { $in: this.reservations.map(reservation => { return reservation._id })}}}).then(reservation => {
                this.cancelled = true
                this.searched = false
                this.reservation = null
                this.search = null
                setTimeout(() => {
                    this.cancelled = false
                    $('#cancelModal').modal('hide')
                }, 10 * 1000)
            })
        }
    }
  }
</script>




// WEBPACK FOOTER //
// CancelBooking.vue?3153a6c8